import { TabStyles } from '@tableau/widgets';
import { cssClass } from '../../style';

const cssPrefix = 'DataRoleDefinitionSubspaceShared';

export const sectionHeaderClass = cssClass(cssPrefix, 'sectionHeader', {
  paddingBottom: TabStyles.Spacing.DefaultSpace,
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: TabStyles.Spacing.MediumSpace,
  marginBottom: '0px',
});

export const sectionTitleClass = cssClass(cssPrefix, 'sectionTitle', {
  fontWeight: 'normal',
  fontSize: '15px',
  margin: 0,
  padding: 0,
});

export const boldClass = cssClass(cssPrefix, 'bold', {fontWeight: 'bold'});
